// EventDispatcher.js
export const dispatchCustomEvent = (eventName, data) => {
	document.dispatchEvent(new CustomEvent(eventName, { detail: data }));
};
